// Nav
export const REMOVE_BADGE = "REMOVE_BADGE";
export const ADD_BADGE = "ADD_BADGE";

// Rails
export const INIT_DATA = "INIT_DATA";
